import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Subject } from 'rxjs';
import { Gtp } from 'src/app/shared/gtp';

@Injectable({
  providedIn: 'root'
})
export class DistanciaEntreMovilesService {

  private filtroForm = new Subject<any>();

  constructor(
    private gtp: Gtp,
    private http: HttpClient
  ) { }

  getFiltroForm(){
    return this.filtroForm.asObservable();
  }

  setFiltroForm(filtro){
    this.filtroForm.next(filtro);
  }

  getDistanciaEntreMoviles(filtro){        
    let user = JSON.parse(this.gtp.getUserData());    
    let params = {
        buscar: filtro.buscar,
        fdesde: filtro.desde,
        fhasta: filtro.hasta,
        itemsPorPagina: filtro.pageSize,
        orderby: filtro.orderby,
        pagina: filtro.pageIndex,
        sort: filtro.sortby,
    }
    return this.http.post(`${environment.baseUrl}controldeflota/distanciarecorrida/${user.cod_cliente}?`, { params: params } );
  }

}
